import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RESET_PASSWORD_URL } from '../../../app.config';
import { AuthnService } from '../../../services/authn.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  otpForm: FormGroup;
  awaitingOtp = false;

  message: string = '';

  constructor(private formBuilder: FormBuilder, public authnService: AuthnService, public router: Router,
    private route: ActivatedRoute, private messageService: MessageService,
    @Inject(RESET_PASSWORD_URL) public resetPasswordUrl: string) {
    this.message = this.getMessage();
    this.loginForm = this.formBuilder.group(
      {
        username: ['', Validators.required],
        password: ['', Validators.required]
      });
    this.otpForm = this.formBuilder.group(
      {
        code: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]]
      });
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    // console.debug('destroying loginComponent');
  }

  login() {
    if (this.loginForm.valid) {
      this.message = 'Authenticating...';
      this.authnService.signIn(this.loginForm.controls['username'].value, this.loginForm.controls['password'].value)
        .subscribe({
          next: (v) => {
            if (v.status === 'pending') {
              this.awaitingOtp = true;
              this.otpForm.reset();
              this.message = v.message;
              this.messageService.showMessage(this.message, false);
            } else {
              this.handleSignedIn(v);
            }
          },
          error: e => {
            console.error('error', e);
            this.authnService.signOut();
            this.message = e.error?.message || "Server connection failure";
            this.messageService.showMessage(this.message, true);
            // stay on login page if failure
          }
        });
    }
  }

  verify() {
    if (this.otpForm.valid) {
      this.message = 'Verifying...';
      this.authnService.verifyOtp(this.loginForm.controls['username'].value, this.otpForm.controls['code'].value)
        .subscribe({
          next: (v) => {
            this.handleSignedIn(v);
          },
          error: e => {
            console.error('error', e);
            this.authnService.signOut(false);
            this.message = e.error?.message || "Server connection failure";
            this.messageService.showMessage(this.message, true);
            // stay on OTP page if failure
          }
        });
    }
  }

  resend() {
    this.otpForm.reset();
    this.login();
  }

  private handleSignedIn(v: any) {
    this.authnService.token = v.token;
    this.router.navigateByUrl(this.route.snapshot.queryParams['returnUrl'] || '/admin');
    this.message = 'You are now connected';
    this.messageService.showMessage(this.message, false);
  }

  resetForm() {
    this.loginForm.reset();
    this.otpForm.reset();
    this.awaitingOtp = false;
    this.message = this.getMessage();
    this.router.navigate(['/login',]);
  }

  getMessage() {
    return ((this.authnService.isAuthenticated) ? 'You are connected' : 'You are currently disconnected');
  }
}